import { ajaxCall, formRequestData } from './ajaxService';
import {getRoleUrl} from '../helpers';
import inMemoryUser from './inMemoryUser';

const constants = window.getConfig;
const ajaxPurchaseOrdersUrl = `${constants.ajax.baseUrl}/purchaseorders`;
export const ajaxGetPurchaseOrders = (params) =>
  new Promise((res, rej) => {
    if (params && params.PurchaseOrderId) {
      ajaxCall(ajaxPurchaseOrdersUrl + `/${params.PurchaseOrderId}`, formRequestData(constants.ajax.methods.get, true))
        .then(res)
        .catch(rej);
    } else {
      ajaxCall(ajaxPurchaseOrdersUrl, formRequestData(constants.ajax.methods.get, true)).then(res).catch(rej);
    }
  });

export const ajaxGetWaitingApprovalPurchaseOrders = () =>
  new Promise((res, rej) => {
    ajaxCall(ajaxPurchaseOrdersUrl + '/waitingapproval', formRequestData(constants.ajax.methods.get, true))
      .then(res)
      .catch(rej);
  });

export const ajaxGetDraftPurchaseOrders = () =>
  new Promise((res, rej) =>
    ajaxCall(ajaxPurchaseOrdersUrl + '/draft', formRequestData(constants.ajax.methods.get, true))
      .then(res)
      .catch(rej)
  );

export const ajaxGetPurchaseOrdersByTime = (startTime, endTime = null) =>
  new Promise((res, rej) => {
    const url = endTime 
      ? `${ajaxPurchaseOrdersUrl}/time/${startTime}/${endTime}`
      : `${ajaxPurchaseOrdersUrl}/time/${startTime}`;
    
    ajaxCall(url, formRequestData(constants.ajax.methods.get, true))
      .then(res)
      .catch(rej);
  });

export const ajaxSavePurchaseOrder = (params) =>
  new Promise((res, rej) => {
    const url = `${constants.ajax.baseUrl}/${getRoleUrl('purchaseorders')}`;
    ajaxCall(url + '/save', formRequestData(constants.ajax.methods.post, true, false, params, true))
      .then(res)
      .catch(rej);
  });

export const ajaxSaveShippingCostPurchaseOrder = (params) =>
  new Promise((res, rej) => {
    const url = `${constants.ajax.baseUrl}/${getRoleUrl('purchaseorders')}`;
    ajaxCall(url + '/saveShippingCost', formRequestData(constants.ajax.methods.post, true, false, params, true))
      .then(res)
      .catch(rej);
  });

export const ajaxSaveAwbPurchaseOrder = (params) =>
  new Promise((res, rej) => {
    const url = `${constants.ajax.baseUrl}/${getRoleUrl('purchaseorders')}`;
    ajaxCall(url + '/saveAwb', formRequestData(constants.ajax.methods.post, true, false, params, true))
      .then(res)
      .catch(rej);
  });

export const ajaxRequestApprovalPurchaseOrder = (params) =>
  new Promise((res, rej) => {
    if (params && params.PurchaseOrderId) {
      const url = `${constants.ajax.baseUrl}/${getRoleUrl('purchaseorders')}`;
      ajaxCall(url + `/requestapproval/${params.PurchaseOrderId}`, formRequestData(constants.ajax.methods.post, true, false, { emailTo: params.emailTo || [] }, true))
        .then(res)
        .catch(rej);
    }
  });

export const ajaxApprovePurchaseOrder = (params) =>
  new Promise((res, rej) => {
    if (params && params.PurchaseOrderId) {
      const url = `${constants.ajax.baseUrl}/${getRoleUrl('purchaseorders')}`;
      ajaxCall(url + `/approve/${params.PurchaseOrderId}`, formRequestData(constants.ajax.methods.put, true))
        .then(res)
        .catch(rej);
    }
  });

export const ajaxRejectPurchaseOrder = (params) =>
  new Promise((res, rej) => {
    if (params && params.PurchaseOrderId) {
      const url = `${constants.ajax.baseUrl}/${getRoleUrl('purchaseorders')}`;
      ajaxCall(url + `/reject/${params.PurchaseOrderId}`, formRequestData(constants.ajax.methods.put, true))
        .then(res)
        .catch(rej);
    }
  });

export const ajaxReceivePurchaseOrder = (params) =>
  new Promise((res, rej) => {
    if (params && params.PurchaseOrderId) {
      const url = `${constants.ajax.baseUrl}/${getRoleUrl('purchaseorders')}`;
      ajaxCall(url + `/receive/${params.PurchaseOrderId}`, formRequestData(constants.ajax.methods.put, true))
        .then(res)
        .catch(rej);
    }
  });

export const ajaxPayPurchaseOrder = (params) =>
  new Promise((res, rej) => {
    if (params && params.PurchaseOrderId && params.proofPaymentPdf) {
      const url = `${constants.ajax.baseUrl}/${getRoleUrl('purchaseorders')}`;
      const data = {
        proof_payment_pdf: params.proofPaymentPdf
      }
      ajaxCall(url + `/pay/${params.PurchaseOrderId}`, formRequestData(constants.ajax.methods.post, true, false, data, true))
        .then(res)
        .catch(rej);
    } else {
      rej(new Error('Purchase order ID and proof of payment PDF are required'));
    }
  });

export const ajaxCancelPurchaseOrder = (params) =>
  new Promise((res, rej) => {
    if (params && params.PurchaseOrderId) {
      const url = `${constants.ajax.baseUrl}/${getRoleUrl('purchaseorders')}`;
      ajaxCall(url + `/cancel/${params.PurchaseOrderId}`, formRequestData(constants.ajax.methods.post, true, false, { reason: params.reason }, true))
        .then(res)
        .catch(rej);
    } else {
      rej(new Error('Purchase order ID and reason are required'));
    }
  });

export const ajaxUploadSupplierQuote = (params) =>
  new Promise((res, rej) => {
    if (params && params.PurchaseOrderId && params.supplierQuotePdf) {
      const url = `${constants.ajax.baseUrl}/${getRoleUrl('purchaseorders')}`;
      const data = {
        supplier_quote_pdf: params.supplierQuotePdf
      }
      ajaxCall(url + `/quote/${params.PurchaseOrderId}`, formRequestData(constants.ajax.methods.post, true, false, data, true))
        .then(res)
        .catch(rej);
    } else {
      rej(new Error('Purchase order ID and supplier quote PDF are required'));
    }
  });

export const ajaxGetApprovalPurchaseOrderUsers = () =>
  new Promise((res, rej) => {
    if ( !inMemoryUser.isAdmin() && !inMemoryUser.isPurchase()) {
      res({ data: [] });
      return;
    }
    const url = `${constants.ajax.baseUrl}/${getRoleUrl('purchaseorders')}`;
    ajaxCall(url + '/users/poapproval', formRequestData(constants.ajax.methods.get, true))
      .then(res)
      .catch(rej);
  });
